<template>
  <v-dialog persistent v-model="show">
    <v-card>
      <v-card-actions>
        <v-btn>保存</v-btn>
        <v-btn @click="show = false">戻る</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-text-field disabled label="費用項目" v-model="charge.chargeItemName"></v-text-field>
        <v-text-field label="金額" v-model="charge.subTotal"></v-text-field>
        <remote-autocomplete
          :rules="charge.subTotal?[v=> !!v || `支払先 is required`]:[]"
          :value="charge.supplier"
          clearable
          placeholder="请输入支払先"
          url="companies/supplier"
        />
        <v-text-field label="コメント" v-model="charge.remark"></v-text-field>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['shipment'],
  data() {
    return {
      show: false,
      charge: {},
    }
  },
  methods: {
    add() {},
    popup(data) {
      this.charge = {
        chargeItemCode: data.chargeItemCode,
        chargeItemName: data.chargeItemName,
      }
      this.show = true
    },
    close() {
      this.show = false
    },
  },
  watch: {},
}
</script>
